import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProcesses(packing_house_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_processes`
    );
  },
};
